export enum DisplayType {
  Private = 1,
  TeamPublic = 2,
  Public = 3,
}
